import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

/**
 * Fluent 2 Label Component
 * https://fluent2.microsoft.design/components/web/react/core/field/usage
 * Typography: Body1Strong (14px, semibold)
 */
const labelVariants = cva(
  'text-sm font-medium leading-5 text-neutral-900 dark:text-neutral-100 peer-disabled:cursor-not-allowed peer-disabled:text-neutral-400 dark:peer-disabled:text-neutral-500'
)

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> & {
      required?: boolean
    }
>(({ className, required, children, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  >
    {children}
    {required && <span className="ml-0.5 text-[#c50f1f] dark:text-[#dc626d]">*</span>}
  </LabelPrimitive.Root>
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }